import { SET_SITES_FROM_SERVER } from "../../constants";

const initialState = {
  sitesFromServer: []
};

const sitesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SITES_FROM_SERVER:
      return {
        sitesFromServer: action.payload
      };

    default:
      return state;
  }
}
 
export default sitesReducer;